module.exports = __webpack_public_path__ + "img/zoom-in.5a09806e.svg";